"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Color_1 = require("../Color/Color");
const Model_1 = require("../Model");
const PaletteExceptions_1 = require("./PaletteExceptions");
const PaletteDefaults_1 = require("./PaletteDefaults");
class Palette extends Model_1.default {
    /**
     * Construttore palette
     * Se il parametro 'palette' è settato, verranno importati i dati.
     *
     * @param {JSONPalette} [palette]
     * @memberof Palette
     */
    constructor(palette) {
        super();
        /**
         * Proprietà da esportare nel file di configuratione
         *
         * @type {Array<string>}
         * @memberof Palette
         */
        this.exportableProperties = ['colors', 'format'];
        /**
         * Palette colori
         *
         * @private
         * @type {Array<Color>}
         * @memberof Palette
         */
        this.colors = [];
        /**
         * Tags
         *
         * @private
         * @type {Array<Color>}
         * @memberof Palette
         */
        this.tags = {};
        this.format = palette && palette.format ? palette.format : PaletteDefaults_1.DEFAULT_COLOR_FORMAT;
        palette && palette.colors && palette.colors.forEach((color) => {
            this.addColor(color.value, color.name, color.tags, color.id);
        });
    }
    //#region Format
    /**
     * Ritorna il formato dei colori
     *
     * @returns {ColorFormat}
     * @memberof Palette
     */
    getFormat() {
        return this.format;
    }
    /**
     * Setta il formato dei colori
     *
     * @param {ColorFormat} format
     * @memberof Palette
     */
    setFormat(format) {
        if (Palette.FORMATS.indexOf(format) < 0)
            throw new PaletteExceptions_1.FormatNotValidException(format, Palette.FORMATS);
        this.format = format;
    }
    /**
     * Ritorna i colori gestiti
     *
     * @static
     * @returns {Array<string>}
     * @memberof Palette
     */
    static getFormats() {
        return Palette.FORMATS;
    }
    //#endregion
    //#region gestione array colori
    /**
     * Setta una nuova palette colori
     *
     * @param {Array<Types.PupsConfig.Palette.Color>} colors
     * @memberof Palette
     */
    setColors(colors) {
        this.colors = [];
        colors && colors.length && colors.forEach((color) => this.addColor(color.name, color.value, color.tags, color.id));
    }
    /**
     * Ritorna la palette colori
     *
     * @returns {Array<Types.PupsConfig.Palette.Color>}
     * @param {boolean} forExport
     * @memberof Palette
     */
    getColors(forExport = false) {
        if (forExport)
            return this.colors.map(c => ({
                id: c.getId(), name: c.getName(), ccName: c.getCcName(), value: c.toString(), tags: c.getTags()
            }));
        return [...this.colors];
    }
    /**
     * Get index of Color
     *
     * @param {Color} color
     * @returns {number}
     * @memberof Palette
     */
    getIndex(color) {
        for (let i = this.colors.length - 1; i >= 0; i--)
            if (this.colors[i].getId() === color.getId())
                return i;
        return -1;
    }
    //#endregion
    //#region get, add, update, remove singolo Color
    /**
     * Aggiunge un colore alla palette colori
     *
     * @param {Types.Color.All} value
     * @param {string} name
     * @param {string} [id]
     * @memberof Palette
     */
    addColor(value, name, tags = [], id) {
        const c = new Color_1.default(value, name, tags, id, this.getFormat());
        this.colors.push(c);
        tags.forEach(tag => {
            if (!(tag in this.tags))
                this.tags[tag] = [c];
            else
                this.tags[tag].push(c);
        });
    }
    getTags() {
        return this.tags;
    }
    /**
     * Ritorna tutti i colori che appartengono ad un tag
     *
     * @param {string} tag
     * @returns {Array<Color>}
     * @memberof Palette
     */
    getAllColorsByTag(tag) {
        if (typeof this.tags[tag] === 'undefined')
            throw new PaletteExceptions_1.TagNotFoundException(tag);
        return this.tags[tag];
    }
    /**
     * Cerca il colore in base all'id
     *
     * @param {string} id
     * @returns {Color}
     * @memberof Palette
     */
    find(id) {
        for (let i = this.colors.length - 1; i >= 0; i--)
            if (this.colors[i].getId() == id)
                return this.colors[i];
        throw new PaletteExceptions_1.ColorNotFoundException(id);
    }
    /**
     * Ritorna il colore associato al parametro name
     *
     * @param {string} name
     * @param {ColorFormat} format
     * @returns {string}
     * @memberof Palette
     */
    get(name, format) {
        for (let i = this.colors.length - 1; i >= 0; i--)
            if (this.colors[i].getName() == name || this.colors[i].getCcName() == name)
                return this.colors[i];
        throw new PaletteExceptions_1.ColorNotFoundException(`Il colore '${name}' non è stato trovato`);
    }
    /**
     * Modifica il nome ed il valore del colore in base all'id
     *
     * @param {Color} color
     * @returns {Boolean} True se l'update è andato a buon fine
     * @memberof Palette
     */
    updateColor(color) {
        const index = this.getIndex(color);
        if (index >= 0) {
            this.colors[index].setName(color.getName());
            this.colors[index].setValue(color.getValue(this.format));
            return true;
        }
    }
    /**
     * Rimuove un colore dalla palette colori in base all'id
     *
     * @param {Color} color
     * @memberof Palette
     */
    removeColor(color) {
        this.colors.splice(this.getIndex(color), 1);
    }
}
/**
 * Formati colore supportati
 *
 * @protected
 * @static
 * @memberof Palette
 */
Palette.FORMATS = ['rgb', 'rgba', 'hsl', 'hsla', 'hsv', 'hsva', 'hex', 'cmyk'];
exports.default = Palette;
//# sourceMappingURL=Palette.js.map